import { paths } from "../paths";

export const dashboardConfigWorkspace = {
    layout: "vertical",
    navColor: "evident",
    navItems: [
        {
            key: "workspace",
            type: "common",
            title: "Verwaltung",
            visible: true,
            feature:"workspace:show",
            items: [
                {
                    key: "usermanagement",
                    type: "common",
                    title: "navbar:usermanagement",
                    href: paths.dashboard.workspace.usermanagement.list,
                    visible: true,
                    feature: "management:users:show",
               
                },
                {
                    key: "clients",
                    type: "common",
                    title: "navbar:clients",
                    href: paths.dashboard.workspace.clients.list,
                    visible: true,
                    feature: "management:mandanten:show",

                },
                {
                    key: "locations",
                    type: "common",
                    title: "navbar:locations",
                    href: paths.dashboard.workspace.locations.list,
                    visible: true,
                    feature: "management:locations:show",

                },
                {
                    key: "devices",
                    type: "common",
                    title: "navbar:devices",
                    href: paths.dashboard.workspace.devices.list,
                    visible: true,
                    feature: "management:devices:show",

                },
                {
                    key: "devicesGroups",
                    type: "common",
                    title: "navbar:devicesGroups",
                    href: paths.dashboard.workspace.devicesGroups.list,
                    visible: true,
                    feature: "management:groups:show",

                },
                {
                    key: "topicMetrics",
                    type: "common",
                    title: "navbar:topicMetrics",
                    href: paths.dashboard.workspace.topicMetrics.list,
                    visible: true,
                    feature: "billing:topics:show",

                },
            ]

        }
    ]
}
